import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useFocusParam = (ready) => {
  const [sp] = useSearchParams();
  const focus = sp.get("focus");
  useEffect(() => {
    if (!focus || !ready) return;
    const el = document.querySelector(`[data-focus="${CSS.escape(focus)}"]`);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add("search-focus");
    const t = setTimeout(() => el.classList.remove("search-focus"), 3000);
    return () => clearTimeout(t);
  }, [focus, ready]);
};
